import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext, EMPTY_OBJECT } from 'commons-ui';
import useService from '../../../useService';
import { dehydrateFormData } from '../../utils/formDataParser';
import { TSubmitSpotlightData, TSpotlightData } from '../../utils/types';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const { requestCreateSpotlight } = useService();

	const createSpotlight = (createdData: TSpotlightData) => {
		setShowLoader(true);

		requestCreateSpotlight(app.appName, createdData).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while creating the spotlight', { type: 'error' });
					setShowLoader(false);
					return;
				}

				showAlert('New Spotlight Created');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: TSubmitSpotlightData) => {
		createSpotlight(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: EMPTY_OBJECT, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
